import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { PrimeTemplate } from 'primeng/api';
import { ConfirmDialog } from 'primeng/confirmdialog';

/**
 * Confirm dialog that renders its message as text.
 *
 * PrimeNG's default template binds the message with innerHTML, so a stored
 * name such as "<b>Hello</b>" is interpreted as markup.
 */
@Component({
  selector: 'shared-confirm-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ConfirmDialog, PrimeTemplate],
  templateUrl: './shared-confirm-dialog.component.html',
  styleUrl: './shared-confirm-dialog.component.scss',
})
export class SharedConfirmDialogComponent {
  dialogStyle = input<Record<string, string> | undefined>(undefined);
}
